module.exports = __webpack_public_path__ + "img/search.3573c092.svg";